// SidebarNavigation.js
import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../styles/SidebarNav.css";
import "../styles/Navbar.css";
import {
	AttachMoney,
	AutoAwesome,
	HelpOutline,
	Home,
	VideoCameraBackRounded,
	ChevronRight,
	ChevronLeft,
	Dashboard,
	Settings,
	PersonAdd,
	Logout,
	CloudUpload,
} from "@mui/icons-material";
import {
	Avatar,
	Divider,
	IconButton,
	ListItemIcon,
	Menu,
	Toolbar,
	Tooltip,
} from "@mui/material";
import { MenuItem } from "@mui/material";
import { useAuth } from "react-oidc-context";

const SidebarNav = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const [expand, setExpand] = useState(false);
	const auth = useAuth();

	const toggleSidebar = () => {
		setExpand(!expand);
	};

	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const logoutRedirectUri =
		process.env.NODE_ENV === "production"
			? "https://magicverse.me"
			: "http://localhost:3000";

	const signOutRedirect = () => {
		localStorage.removeItem("auth_user");
		auth.removeUser();
		// const clientId = "63lshnga7pf7jc29penkr0jclf";
		// const logoutUri = logoutRedirectUri;
		// const cognitoDomain =
		// 	"https://us-east-1lalmerydc.auth.us-east-1.amazoncognito.com";
		// window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
		// 	logoutUri
		// )}`;
	};

	return (
		<>
			<div
				className={`sidebar-navigation transition-all duration-300 fixed left-0 top-0 h-screen z-50`}
				style={{
					width: expand ? "250px" : "100px",
					overflow: "hidden",
					boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
					background:
						"linear-gradient(180deg, #1a237e 0%, #283593 100%)",
				}}
			>
				<div className="sidebar relative top-0 bottom-0 left-0 h-[100vh] w-full overflow-hidden">
					{/* Logo Section with improved styling */}
					{expand ? (
						<div
							className="logo flex flex-col justify-center items-center h-24 gap-2 mt-6 mb-8 cursor-pointer"
							// onClick={() => navigate("/")}
						>
							<div className="p-3 rounded-full bg-white/10 mb-1">
								<AutoAwesome
									className="!fill-white"
									fontSize="large"
								/>
							</div>
							<div className="logo text-3xl text-white alkatra-700 font-bold">
								MagicVerse
							</div>
						</div>
					) : (
						<div
							className="logo flex flex-col justify-center items-center gap mt-6 mb-12 cursor-pointer"
							// onClick={() => navigate("/")}
						>
							<div className="p-2 rounded-full bg-white/10 mb-2">
								<AutoAwesome className="!fill-white !text-3xl" />
							</div>
							<div className="logo text-base text-white alkatra-700 font-medium">
								Magic
							</div>
							<div className="logo text-base text-white alkatra-700 mt-[-5px] font-medium">
								Verse
							</div>
						</div>
					)}

					{/* Navigation Links with improved styling */}
					{expand ? (
						<div className="flex flex-col px-3 gap-2">
							<Link
								className={`flex items-center rounded-lg my-1 py-3 px-4 text-xl ${
									location.pathname === "/landing"
										? "bg-indigo-800/70 shadow-md"
										: ""
								} hover:bg-indigo-800/50 transition-all duration-200`}
								to="/landing"
							>
								<Home
									className="!fill-white"
									fontSize="medium"
								/>
								<div className="ide_bar_link mx-3 text-white font-medium">
									Home
								</div>
							</Link>
							<Link
								className={`flex items-center rounded-lg my-1 py-3 px-4 text-xl ${
									location.pathname === "/landing/VideoList"
										? "bg-indigo-800/70 shadow-md"
										: ""
								} hover:bg-indigo-800/50 transition-all duration-200`}
								to="/landing/VideoList"
								onClick={(event) => {
									event.preventDefault();
									if (
										location.pathname ===
										"/landing/VideoList"
									)
										return;
									navigate("/landing/VideoList");
								}}
							>
								<VideoCameraBackRounded
									className="!fill-white"
									fontSize="medium"
								/>
								<div className="ide_bar_link mx-3 text-white font-medium">
									Created Videos
								</div>
							</Link>
							<Link
								className={`flex items-center rounded-lg my-1 py-3 px-4 text-xl ${
									location.pathname === "/upload-video"
										? "bg-indigo-800/70 shadow-md"
										: ""
								} hover:bg-indigo-800/50 transition-all duration-200`}
								to="/upload-video"
							>
								<CloudUpload
									className="!fill-white"
									fontSize="medium"
								/>
								<div className="ide_bar_link mx-3 text-white font-medium">
									Upload
								</div>
							</Link>
							<Link
								className={`flex items-center rounded-lg my-1 py-3 px-4 text-xl ${
									location.pathname ===
									"/landing/subscription"
										? "bg-indigo-800/70 shadow-md"
										: ""
								} hover:bg-indigo-800/50 transition-all duration-200`}
								to="/landing/subscription"
							>
								<AttachMoney
									className="!fill-white"
									fontSize="medium"
								/>
								<div className="ide_bar_link mx-3 text-white font-medium">
									Buy Credits
								</div>
							</Link>
							<Link
								className={`flex items-center rounded-lg my-1 py-3 px-4 text-xl ${
									location.pathname === "/landing/support"
										? "bg-indigo-800/70 shadow-md"
										: ""
								} hover:bg-indigo-800/50 transition-all duration-200`}
								to="/landing/support"
							>
								<HelpOutline
									className="!fill-white"
									fontSize="medium"
								/>
								<div className="ide_bar_link mx-3 text-white font-medium">
									Support
								</div>
							</Link>
						</div>
					) : (
						<div className="flex flex-col gap-4 mx-2">
							<Link
								className={`flex flex-col p-3 items-center rounded-lg text-xl ${
									location.pathname === "/landing"
										? "bg-indigo-800/70 shadow-md"
										: ""
								} hover:bg-indigo-800/50 transition-all duration-200`}
								to="/landing"
							>
								<Home
									className="!fill-white mb-1"
									fontSize="medium"
								/>
								<div className="text-xs text-white font-medium">
									Home
								</div>
							</Link>
							<Link
								className={`flex flex-col p-3 items-center rounded-lg text-xl ${
									location.pathname === "/landing/VideoList"
										? "bg-indigo-800/70 shadow-md"
										: ""
								} hover:bg-indigo-800/50 transition-all duration-200`}
								to="/landing/VideoList"
								onClick={(event) => {
									event.preventDefault();
									if (
										location.pathname ===
										"/landing/VideoList"
									)
										return;
									navigate("/landing/VideoList");
								}}
							>
								<VideoCameraBackRounded
									className="!fill-white mb-1"
									fontSize="medium"
								/>
								<div className="text-xs text-white font-medium">
									Videos
								</div>
							</Link>
							<Link
								className={`flex flex-col p-3 items-center rounded-lg text-xl ${
									location.pathname === "/upload-video"
										? "bg-indigo-800/70 shadow-md"
										: ""
								} hover:bg-indigo-800/50 transition-all duration-200`}
								to="/upload-video"
							>
								<CloudUpload
									className="!fill-white mb-1"
									fontSize="medium"
								/>
								<div className="text-xs text-white font-medium">
									Upload
								</div>
							</Link>
							<Link
								className={`flex flex-col p-3 items-center rounded-lg text-xl ${
									location.pathname ===
									"/landing/subscription"
										? "bg-indigo-800/70 shadow-md"
										: ""
								} hover:bg-indigo-800/50 transition-all duration-200`}
								to="/landing/subscription"
							>
								<AttachMoney
									className="!fill-white mb-1"
									fontSize="medium"
								/>
								<div className="text-xs text-white font-medium">
									Credits
								</div>
							</Link>
							<Link
								className={`flex flex-col p-3 items-center rounded-lg text-xl ${
									location.pathname === "/landing/support"
										? "bg-indigo-800/70 shadow-md"
										: ""
								} hover:bg-indigo-800/50 transition-all duration-200`}
								to="/landing/support"
							>
								<HelpOutline
									className="!fill-white mb-1"
									fontSize="medium"
								/>
								<div className="text-xs text-white font-medium">
									Support
								</div>
							</Link>
						</div>
					)}

					{/* User profile section at bottom */}
					<div className="absolute bottom-16 left-0 right-0 mx-3">
						<div
							className={`flex ${
								expand
									? "items-center px-4 py-2"
									: "flex-col items-center py-2"
							} rounded-lg bg-white/10 hover:bg-white/15 transition-all duration-200 cursor-pointer`}
							onClick={handleClick}
						>
							<div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-indigo-800 font-bold">
								U
							</div>
							{expand && (
								<div className="ml-3 text-white font-medium text-sm">
									User Account
								</div>
							)}
						</div>
						<Menu
							anchorEl={anchorEl}
							id="account-menu"
							open={open}
							onClose={handleClose}
							onClick={handleClose}
							slotProps={{
								paper: {
									elevation: 0,
									sx: {
										overflow: "visible",
										filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
										mt: -1.5,
										ml: -0.5,
										"& .MuiAvatar-root": {
											width: 32,
											height: 32,
											ml: -0.5,
											mr: 1,
										},
										"&::before": {
											content: '""',
											display: "block",
											position: "absolute",
											bottom: 0,
											left: expand ? 24 : 34,
											width: 10,
											height: 10,
											bgcolor: "background.paper",
											transform:
												"translateY(50%) rotate(-45deg)",
											zIndex: 0,
										},
									},
								},
							}}
							transformOrigin={{
								horizontal: "right",
								vertical: "bottom",
							}}
							anchorOrigin={{
								horizontal: "right",
								vertical: "top",
							}}
						>
							<MenuItem
								onClick={() => {
									if (location.pathname === "/profile")
										return; // If already on the page, do nothing
									// setLoading(true);
									navigate("/profile");
								}}
							>
								<Avatar /> Profile
							</MenuItem>
							<MenuItem onClick={handleClose}>
								<Avatar /> My account
							</MenuItem>
							<Divider />
							<MenuItem onClick={handleClose}>
								<ListItemIcon>
									<PersonAdd fontSize="small" />
								</ListItemIcon>
								Add another account
							</MenuItem>
							<MenuItem onClick={handleClose}>
								<ListItemIcon>
									<Settings fontSize="small" />
								</ListItemIcon>
								Settings
							</MenuItem>
							<MenuItem onClick={signOutRedirect}>
								<ListItemIcon>
									<Logout fontSize="small" />
								</ListItemIcon>
								Logout
							</MenuItem>
						</Menu>
					</div>

					{/* Expand/Collapse Button with improved styling */}
					<div
						className="fixed bottom-6 transform transition-all duration-300"
						style={{
							left: expand ? "220px" : "70px",
						}}
					>
						<button
							onClick={toggleSidebar}
							className="bg-indigo-600 p-2 rounded-full shadow-lg hover:bg-indigo-500 transition-colors flex justify-center items-center"
						>
							{expand ? (
								<ChevronLeft
									className="!fill-white"
									// fontSize="small"
								/>
							) : (
								<ChevronRight
									className="!fill-white"
									// fontSize="small"
								/>
							)}
						</button>
					</div>
				</div>
			</div>
			{expand && (
				<div
					className="fixed w-full h-screen bg-black z-10 opacity-35 top-0 left-0"
					onClick={() => {
						setExpand(false);
					}}
				></div>
			)}
		</>
	);
};

export default SidebarNav;
